import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class MessageMediaModel extends FileModel {
  static get path() {
    return '/backend/message_media/{?id}';
  }

  @computed
  get mediaFileName(): string {
    return this.get('mediaFileName');
  }

  @computed
  get objectUrl(): string {
    return this.get('objectUrl');
  }

  @computed
  get messageId(): id {
    return this.get('message.id');
  }
}
